import { Container } from '@/common/ui/containers/Container';
import { IBreadcrumbsItem } from '@/shared/Breadcrumbs/domain/Breadcrumbs.domain';
import Layout from '@/shared/Layout/ui/Layout';
import * as S from './AuthorsPage.styles';
import { TAuthorShortWithImage } from '@/entities/Blogs/service/fetchBlogBySlug';
import { myImageLoader } from '@/lib/imageLoader';
import { MainImage } from './AuthorPage.styles';
import { AuthorsLinks } from './AuthorsLinks';
import Link from 'next/link';
import { IMeta } from '@/common/domain/Meta.domain';
import { CommonMeta } from '@/common/ui/meta/CommonMeta';
import { MartkdownHtml } from '@/shared/MarkdownHtml';

const AuthorsPage = ({
    meta,
    authors,
    breadcrumbs,
}: {
    meta: IMeta;
    authors: TAuthorShortWithImage[];
    breadcrumbs: IBreadcrumbsItem[];
}) => {
    return (
        <Layout breadcrumbs={breadcrumbs}>
            <CommonMeta
                title={meta.title}
                description={meta.description}
                slug={'/blog/authors/'}
                canonical={meta.canonical}
            />
            <Container>
                <S.Title>Authors</S.Title>
                <S.Grid>
                    {authors.map((i) => (
                        <S.Card key={i.slug}>
                            <S.AuthorImageWrapper>
                                <S.AuthorImage>
                                    {Boolean(i.image) && (
                                        <MainImage
                                            loader={myImageLoader}
                                            src={i.image}
                                            width={400}
                                            height={400}
                                            alt="Profile photo"
                                        />
                                    )}
                                </S.AuthorImage>
                            </S.AuthorImageWrapper>
                            <S.AuthorContent>
                                <S.AuthorTitle>{i.title}</S.AuthorTitle>
                                <S.SocialWrapper>
                                    <AuthorsLinks links={i.links} />
                                </S.SocialWrapper>
                                <S.AuthorDescription>
                                    <MartkdownHtml content={i.description} />
                                </S.AuthorDescription>
                                <Link passHref href={`/blog/authors/${i.slug.toLowerCase()}/`}>
                                    <S.AuthoButton>Author profile</S.AuthoButton>
                                </Link>
                            </S.AuthorContent>
                        </S.Card>
                    ))}
                </S.Grid>
            </Container>
        </Layout>
    );
};

export default AuthorsPage;
